import React from 'react';
import classNames from 'classnames';
import ViewList from '@mui/icons-material/ViewList';

import { Typo } from 'uikit/content';
import { Insignias } from 'uikit/insignias';

import i18n from 'i18next';
import VideoContentInformation from './videoContentInformation';
import VideoContentBox from './videoContentBox';
import VideoContentBoxItem from './videoContentBoxItem';
import VideoContentSchedule from './videoContentSchedule';
import VideoSpeakers from './videoSpeakers';

import styles from '../styles/videoContent.module.scss';
import VideoAgenda from './videoAgenda';

/* eslint-disable camelcase */
const VideoContent = ({
  endAt,
  skills,
  skillsReputation,
  speakers,
  startAt,
  title,
  description,
  dropEnrollment,
  reportVideo,
  published_at,
  duration,
  difficulty,
  author,
  is_favorited,
  vote_total,
  vote_user,
  favouriteVideo,
  unfavouriteVideo,
  relatedCourses,
  updateReview,
  agendaItems,
  selectedAgendaItem,
  viewAgendaItem,
  enrollmentStatus,
  isEnrolled,
  isSettingEnrollmentStatus,
  setEnrollmentStatus,
  type,
  waitlistSpot,
  waitlistTotal,
  learning_objectives,
  display_learning_objectives,
  enrollmentData,
}) => (
  <div
    className={classNames(styles.container, {
      [styles.hasSidebar]: relatedCourses.length || skills.length,
    })}
  >
    <div>
      <VideoContentInformation
        title={title}
        description={description}
        isEnrolled={isEnrolled}
        dropEnrollment={dropEnrollment}
        reportVideo={reportVideo}
        published_at={published_at}
        duration={duration}
        difficulty={difficulty}
        author={author}
        is_favorited={is_favorited}
        vote_total={vote_total}
        vote_user={vote_user}
        favouriteVideo={favouriteVideo}
        unfavouriteVideo={unfavouriteVideo}
        updateReview={updateReview}
        type={type}
        learning_objectives={learning_objectives}
        display_learning_objectives={display_learning_objectives}
        enrollmentData={enrollmentData}
      />
      <div className={styles.agendaContainer}>
        {endAt && Date.now() < new Date(endAt).getTime() && (
          <VideoContentSchedule
            endAt={endAt}
            enrollmentStatus={enrollmentStatus}
            isSettingEnrollmentStatus={isSettingEnrollmentStatus}
            setEnrollmentStatus={setEnrollmentStatus}
            speakers={speakers}
            startAt={startAt}
            waitlistSpot={waitlistSpot}
            waitlistTotal={waitlistTotal}
          />
        )}
        {Boolean(agendaItems?.length) && (
          <VideoAgenda
            isEnrolled={isEnrolled}
            agendaItems={agendaItems}
            selectedAgendaItem={selectedAgendaItem}
            viewAgendaItem={viewAgendaItem}
            eventStartAt={startAt}
            eventEndAt={endAt}
          />
        )}
        {Boolean(speakers?.length) && <VideoSpeakers speakers={speakers} />}
      </div>
    </div>
    <div className={styles.sidebar}>
      {Boolean(skills.length) && (
        <VideoContentBox
          label={
            <Insignias
              className={styles.reputation}
              insignias={[
                {
                  icon: 'reputation',
                  text: skillsReputation,
                  tooltip: i18n.t('reputation'),
                },
              ]}
              insigniasIconSize={18}
            />
          }
          shouldWrap
          title={i18n.t('skills')}
        >
          {skills.map((skill) => (
            <VideoContentBoxItem hasBorder key={skill.id}>
              <span className={styles.dot} style={{ backgroundColor: skill.hex_color }} />
              <Typo variant="s01">{skill.name}</Typo>
            </VideoContentBoxItem>
          ))}
        </VideoContentBox>
      )}
      {Boolean(relatedCourses.length) && (
        <VideoContentBox title={i18n.t('related-courses')}>
          {relatedCourses.map((course) => (
            <VideoContentBoxItem key={course.id}>
              <ViewList className={styles.icon} sx={{ height: 18, width: 18 }} />
              <Typo variant="s02">{course.name}</Typo>
            </VideoContentBoxItem>
          ))}
        </VideoContentBox>
      )}
    </div>
  </div>
);

export default React.memo(VideoContent);
